import React from 'react';
import AppBar from '../../components/AppBar';

export default function Layout(props) {                
    
    return (
        <div>    
            <AppBar loading={props.loading || false}/>                                        
            { props.children }
        </div>
    )
}    